import CitiesService from '@/api/CitiesService.js'
import Vue from 'vue'
export const citiesModule = {
  namespaced: true,
  state: () => ({
    citiesData: [],
    citiesLoadStatus: 'request',
    paginationCitiesStateParams: {
      count: 0,
      limit: 2000,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationCitiesStateParams.total /
        state.paginationCitiesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.citiesData = [...data]
    },
    create(state, data) {
      state.citiesData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.citiesData.findIndex((x) => x.cities__id == data.id)
      Object.assign(state.citiesData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.citiesData.findIndex((x) => x.cities__id == id)

      state.citiesData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationCitiesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.citiesLoadStatus = 'request'
    },
    load_success(state) {
      state.citiesLoadStatus = 'success'
    },
    load_error(state) {
      state.citiesLoadStatus = 'error'
    }
  },
  actions: {
    getCitiesAll({ commit }, params) {
      commit('load_request')
      CitiesService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createCitiesData({ commit }, createData) {
      CitiesService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editCitiesMultiple({ commit }, { id, dataEdit }) {
      CitiesService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteCitiesData({ commit }, id) {
      // commit("load_request");
      CitiesService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
